import { Components } from '@mui/material/styles';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const MuiMenuItem: Components['MuiToggleButtonGroup'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      margin: pxToEm(4),
    },
  },
};

export const MuiToggleButtonGroup: Components['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      backgroundColor: palette.grey[200],
      borderRadius: '20px',
      '& .MuiToggleButtonGroup-grouped': {
        margin: pxToEm(4),
        border: 0,
        padding: `${pxToEm(4)} ${pxToEm(6)}`,
        width: '30px',

        color: palette.grey['A400'],
        '&:not(:first-of-type)': {
          borderRadius: '20px',
        },
        '&:first-of-type': {
          borderRadius: '20px',
        },
        '&.Mui-disabled': {
          border: 0,
        },
        '&:hover, &:active, &.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: palette.common.white,
        },
      },
    },
  },
};
